import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/common/SEO';
import '../styles/pages/DonatePage.scss';
import RazorpayService from '../services/razorpayService';
import donateBackground from '../assets/images/donateBackground.png';
import donatelogo from '../assets/images/donatelogo.png';
import IgniteImpact from '../assets/images/IgniteImpact.png';
import DriveChange from '../assets/images/DriveChange.png';
import EveryRupeeCounts from '../assets/images/EveryRupeeCounts.png';
import albert_flores from '../assets/images/albert_flores.svg';
import Contactus from '../assets/images/contactus.svg'; 
import contactlogo from '../assets/images/contactlogo.png';
import questionMark from '../assets/images/questionMark.svg';
import bg_donate_left from '../assets/images/bg_donate_left.png';
import donate_hero_bg from '../assets/images/donate_hero_bg.png';
import bg_donate_right from '../assets/images/bg_donate_right.png';
import ContactMainIconSVG from '../assets/images/contactus.svg';
import { useNavigate } from 'react-router-dom';
const DonatePage: React.FC = () => {
  const navigate=useNavigate();
  const [donationAmount, setDonationAmount] = useState(100);
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);
  const [otherAmount, setOtherAmount] = useState<string>('');
      const [openFaq, setOpenFaq] = useState(0);
  

  const donationOptions = [
    [30, 40, 50, 100],
    [150, 300, 450, 500],
    [1000, 1500, 3000, 4000]
  ];

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDonationAmount(parseInt(event.target.value));
  };

  const handleAmountSelect = (amount: number) => {
    setSelectedAmount(amount);
    setOtherAmount(amount.toString());
  };

  const handleOtherAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setOtherAmount(value);
    
    // If the input is a valid number and matches one of the predefined amounts, highlight that button
    const numValue = parseInt(value);
    if (!isNaN(numValue)) {
      // Check if this value matches any of the predefined amounts
      const isPresetAmount = donationOptions.flat().includes(numValue);
      setSelectedAmount(isPresetAmount ? numValue : null);
    } else {
      setSelectedAmount(null);
    }
  };

   const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? -1 : index);
};

     const faqs = [
        {
            question: "Why should I donate to grassroots community programs?",
            answer: "When you donate to grassroot community programs, you support real, local change—empowering families through education, health, and livelihood support."
        },
        {
            question: "What does \"ignite social impact donations\" mean at Almawakening?",
            answer: "Our goal is to ignite social impact donations by showing donors how their contributions directly uplift underserved communities."
        },
        {
            question: "How do donations help communities?",
            answer: "Your donations help communities by funding education, medical camps, skill training, and women's empowerment initiatives across India."
        },
        {
            question: "What are the top community support donations in India?",
            answer: "Almawakening is recognized for top community support donations in India, thanks to our transparent work in rural health and education."
        },
        {
            question: "Can I read beneficiary stories on your donation site?",
            answer: "Yes! Visit our site to explore beneficiary stories and see the real impact your donation creates."
        }
    ];

  const handleContribute = async () => {
    const finalAmount = selectedAmount || parseInt(otherAmount) || 0;
    console.log('Contributing amount:', finalAmount);
    
    if (!RazorpayService.validateAmount(finalAmount)) {
      alert('Please select or enter a valid donation amount');
      return;
    }

    try {
      const razorpayService = RazorpayService.getInstance();
      await razorpayService.openPayment(finalAmount, 'Community Support Donation');
    } catch (error) {
      console.error('Payment initiation failed:', error);
      alert('Unable to initiate payment. Please try again.');
    }
  };

  const handleBeASupport = async () => {
    if (!RazorpayService.validateAmount(donationAmount)) {
      alert('Please adjust the donation amount using the slider');
      return;
    }

    try {
      const razorpayService = RazorpayService.getInstance();
      await razorpayService.openPayment(donationAmount, 'General Support Donation');
    } catch (error) {
      console.error('Payment initiation failed:', error);
      alert('Unable to initiate payment. Please try again.');
    }
  };

  return (
    <>
      <SEO
        title="Donate"
        description="Support our mission by donating to Almawakening. Your contribution helps us create positive change in communities."
        keywords="donate, support, contribution, charity, nonprofit, almawakening"
        path="/donate"
        ogImage="https://www.almawakening.org/og-image-donate.jpg"
      />
      
      <Layout>
        <div className="donate-page">
          {/* Hero Section */}
          <section className="hero-section">
            <div className="hero-background">
              {/* Background Images */}
              <div className="hero-bg-main">
                <img src={donate_hero_bg} alt="" className="hero-bg-image" />
              </div>
              <div className="hero-bg-left">
                <img src={bg_donate_left} alt="" className="hero-bg-left-image" />
              </div>
              <div className="hero-bg-right">
                <img src={bg_donate_right} alt="" className="hero-bg-right-image" />
              </div>
              
              <div className="hero-content">
                <div className="hero-text">
                  <h1>Donate to Grassroots Community Programs</h1>
                  <p>Join hands to uplift underserved communities through impactful giving. Your support ignites real change, creates hope, and builds a better future.</p>
                </div>
                <div className="hero-image-container">
                  <img src={donatelogo} alt="Community support" className="hero-image" />
                </div>
              </div>
            </div>
          </section>

          {/* Cards Section */}
          <section className="cards-section">
            <div className="cards-container">
              <div className="card card-purple">
                <div className="card-icon">♥</div>
                <h3 className="card-title"> Ignite Social Impact Donations</h3>
                <p className="card-description">
                Support causes that spark long-lasting, grassroots transformation.
                </p>
              </div>
              
              <div className="card card-coral">
                <div className="card-icon">✦</div>
                <h3 className="card-title">Drive Real Change</h3>
                <p className="card-description">
                Empower communities with sustainable growth opportunities.
                </p>
              </div>
              
              <div className="card card-yellow">
                <div className="card-icon">⚡</div>
                <h3 className="card-title">Every Rupee Makes a Difference</h3>
                <p className="card-description">
                Small contributions lead to meaningful support for those in need.
                </p>
              </div>
            </div>
          </section>

          {/* Interactive Donation Section */}
          <section className="donation-section">
            <div className="donation-container">
              <h2 className="donation-title">Learn How Your Gift Helps</h2>
              <p className="donation-subtitle">Even the smallest contribution can make a difference.</p>
              
              <div className="slider-container">
                <div className="slider-labels">
                  <span className="slider-min">₹1</span>
                  <span className="slider-max">₹1000</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="1000"
                  value={donationAmount}
                  onChange={handleSliderChange}
                  className="donation-slider"
                />
              </div>
              
              <div className="amount-display">
                <span className="amount-label">Total Rupees</span>
                <div className="amount-value">₹ {donationAmount}</div>
              </div>
              
              <div className="donation-cards">
                <div className="donation-card">
                  <h4>Ignite Impact</h4>
                  <p>Spark joy by sharing your cause and positive impact it brings. 
                     Clearly express how contribution will make meaningful difference.</p>
                </div>
                
                <div className="donation-card">
                  <h4>Drive Change</h4>
                  <p>Every contribution helps uplift real people and communities 
                     through sustainable, grassroots initiatives.</p>
                </div>
                
                <div className="donation-card">
                  <h4>Every Rupee Counts</h4>
                  <p>No matter the amount, your support brings hope, healing, 
                     and opportunity to someone who truly needs it.</p>
                </div>
              </div>
              
              <button className="support-button" onClick={handleBeASupport}>Be a Support</button>
            </div>
          </section>
          <section className="amount-selection-section">
            <div className="amount-selection-container">
              <div className="amount-selection-content">
                <div className="amount-title-section">
                  <h2 className="amount-title">
                  Be a Helping Hand for a Better Cause
                  </h2>
                  <p>Support India's most impactful grassroots programs with your chosen amount</p>
                  <p>Read inspiring beneficiary stories showing how each donation changes lives.
                  </p>
                </div>
                
                <div className="amount-options-section">
                  <div className="amount-grid">
                    {donationOptions.map((row, rowIndex) => (
                      <div key={rowIndex} className="amount-row">
                        {row.map((amount) => (
                          <button
                            key={amount}
                            className={`amount-button ${selectedAmount === amount ? 'active' : ''}`}
                            onClick={() => handleAmountSelect(amount)}
                          >
                            ₹{amount}
                          </button>
                        ))}
                      </div>
                    ))}
                  </div>
                  
                  <div className="amount-actions">
                    <input
                      type="number"
                      placeholder="Other Amount"
                      value={otherAmount}
                      onChange={handleOtherAmountChange}
                      className="other-amount-input"
                    />
                    <button 
                      className="contribute-button"
                      onClick={handleContribute}
                    >
                      Contribute
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Testimonial Section */}
          <section className="testimonial-section">
            <div className="testimonial-container">
              <blockquote className="testimonial-quote">
                When you give to Almawakening, you're investing in real people and real stories.
              </blockquote>
              
              <button onClick={() =>{navigate('/get-involved')}} className="circle-button">Join Our Circle of Hope – Top Community Support Donations India</button>
              
              <p className="consistent-support">Your donations support India's most trusted grassroots programs.</p>
              
              <div className="testimonial-content">
                <div className="testimonial-text">
                  <h3>"My donation to Almawakening Foundation has created real impact in 
                      communities that needed it most."</h3>
                  
                  <p>"Through their transparent programs, I can see exactly how my contribution 
                     supports education, healthcare, and skill development initiatives that 
                     truly transform lives across India."</p>
                </div>
                
                <div className="testimonial-image">
                  <img src={albert_flores} alt="Albert Flores" />
                </div>
              </div>
              
              <div className="testimonial-navigation">
                <button className="nav-button nav-prev">←</button>
                <button className="nav-button nav-next">→</button>
              </div>
            </div>
          </section>

          {/* Amount Selection Section */}
        

            
{/* Contact Section */}
                <section className="contact-section">
                    <div className="container">
                        <div
                            className="contact-card"
                            // Correct placement of the style prop inside the div's opening tag
                            style={{
                                // backgroundImage: `url(${Contactus})`, // Using the renamed import for the background SVG
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                
                            }}
                        >
                            <div className="contact-icon">
                                <img src={ContactMainIconSVG} alt="Contact Us" className="w-12 h-12" /> {/* Using renamed import */}
                            </div>
                            <div className="contact-content">
                                <h2>Contact Us</h2>
                                <p>Have questions about our programs or need support? Our dedicated team is here to help. Contact us for assistance and guidance.</p>
                                <div className="contact-info">
                                    <div className="contact-item">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.33940 8.3616L4.79126 9.13616C5.90756 11.8616 8.13844 14.0924 10.8638 15.2087L11.6384 13.6606C11.866 13.2679 12.2955 13.0493 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.82030 18 2 12.1797 2 5V3Z" fill="currentColor"/>
                                        </svg>
                                        <span>+91 72369 89237</span>
                                    </div>
                                    <div className="contact-item">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M2.5 6.5L9.5 11.5C9.77614 11.6913 10.2239 11.6913 10.5 11.5L17.5 6.5M4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6C2 4.89543 2.89543 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <span>almawakeningfoundation@gmail.com</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
           
            {/* FAQ Section */}
                <section className="faq-section">
                    <div className="container">
                        <div className="faq-header">
                            <div className="faq-icon">
                                <img src={questionMark} alt="FAQ" />
                            </div>
                            <h2>Frequently Asked Questions</h2>
                            <p>See what people often asks us?</p>
                        </div>
                        <div className="faq-list">
                            {faqs.map((faq, index) => (
                                <div key={index} className={`faq-item ${openFaq === index ? 'active' : ''}`}>
                                    <button 
                                        className="faq-question"
                                        onClick={() => toggleFaq(index)}
                                    >
                                        <span>{faq.question}</span>
                                        <div className="faq-toggle">
                                            {openFaq === index ? (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                                                    <path d="M8 12h8" stroke="currentColor" strokeWidth="2"/>
                                                </svg>
                                            ) : (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                                                    <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="2"/>
                                                </svg>
                                            )}
                                        </div>
                                    </button>
                                    <div className={`faq-answer ${openFaq === index ? 'show' : ''}`}>
                                        <p>{faq.answer}</p>
                                    </div>
                                    {index < faqs.length - 1 && <div className="faq-divider"></div>}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
        </div>
      </Layout>
    </>
  );
};

export default DonatePage;